import { loading, unloading } from '../shared';
import AuthService from '../../services/authservice';

interface fetchBlobOptions {
    fileName: string;
    url: string;
    type: 'GET' | 'POST';
    parameters: any;
    contentType: string;
    beforeSending: () => void;
}

type fetchBlobType = (obj: fetchBlobOptions) => Promise;

export const fetchBlob: fetchBlobType = ({
    fileName,
    url,
    type = 'GET',
    parameters = null,
    contentType = 'application/json; charset=utf-8',
    beforeSending = loading
}): Promise =>
    new Promise((resolve, reject) => {
        const headers = AuthService.getAccessTokenHeader();

        $.ajaxSetup({
            beforeSend: function (jqXHR, settings) {
                if (settings.dataType === 'binary') {
                    settings.xhr().responseType = 'arraybuffer';
                    settings.processData = false;
                }
            }
        });

        $.ajax({
            type,
            url,
            crossDomain: true,
            headers,
            data: type === 'POST' ? JSON.stringify(parameters) : parameters,
            dataType: 'binary',
            timeout: 120000,
            processData: true,
            contentType,
            statusCode: {
                401() {
                    try {
                        AuthService.signinPopup();
                    } catch (err) {
                        console.error(err.message);
                    }
                }
            },

            beforeSend() {
                beforeSending();
            },

            complete() {
                unloading();
            },

            error(xhr, textStatus, errorThrown) {
                unloading();
                reject(new Error(errorThrown));
            },

            success(res, status, xhr) {
                let contentName = '';
                let content = xhr.getResponseHeader('content-disposition');
                if (content) {
                    try {
                        contentName = decodeURIComponent(content.split(";")[2].replace(" filename*=UTF-8''", ''));
                    } catch (e) {
                        contentName = '';
                    }
                }
                let blob = res;
                if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                    //IE 10+
                    window.navigator.msSaveBlob(blob, fileName || contentName);
                } else {
                    //Firefox, Chrome
                    let a = document.createElement("a");
                    let blobUrl = window.URL.createObjectURL(new Blob([blob], {
                        type: blob.type
                    }));
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = blobUrl;
                    a.download = fileName || contentName;
                    a.click();
                }
                resolve();
            }
        });
    });



// WEBPACK FOOTER //
// ./src/scripts/api/fetchBlob.js